// import React from "react";
// import { FaEye } from "react-icons/fa";

// const LegacyComponent = ({ leagcyData }) => {

//   const data = leagcyData || [];
//   const percentage = "";

//   const maxRows = data.reduce((max, legacy) => {
//     return legacy.data?.length > max ? legacy.data.length : max;
//   }, 0);

//   return (
//     <div className="p-6 flex items-center ml-20 mt-20">
//       <table className="border-collapse text-center w-2/3">
//         <thead>
//           <tr className="border-b border-white font-bold">
//             <th className="py-2">%</th>
//             {data.map((legacy, i) => (
//               <React.Fragment key={i}>
//                 <th className="py-2">{legacy.legacy_name}</th>
//                 <th className="py-2">doc</th>
//               </React.Fragment>
//             ))}
//           </tr>
//         </thead>
//         <tbody>
//           {Array.from({ length: maxRows }).map((_, rowIndex) => (
//             <tr key={rowIndex}>
//               {rowIndex === maxRows - 1 ? (
//                 <td className="py-2 font-bold">{percentage}</td>
//               ) : (
//                 <td></td>
//               )}
//               {data.map((legacy, colIndex) => {
//                 const itemName = legacy.data[rowIndex]?.item_name || "";
//                 return (
//                   <React.Fragment key={colIndex}>
//                     <td className="py-2 text-cyan-400">
//                       {itemName ? itemName : "-"}
//                     </td>
//                     <td className="py-2">
//                       {itemName && <FaEye className="mx-auto cursor-pointer text-secondary" />}
//                     </td>
//                   </React.Fragment>
//                 );
//               })}
//             </tr>
//           ))}
//           <tr className="border-t border-white font-bold text-secondary">
//             <td className="py-2">Total</td>
//             {data.map((legacy, i) => (
//               <React.Fragment key={i}>
//                 <td className="py-2 ">
//                   {legacy.total_initial_amount || "-"}
//                 </td>
//                 <td></td>
//               </React.Fragment>
//             ))}
//           </tr>
//         </tbody>
//       </table>
//     </div>
//   );
// };

// export default LegacyComponent;




import React, { useEffect, useState } from "react";
import { FaEye } from "react-icons/fa";
import DocModal from "./DocModal";
import { formatNumber } from "../../../../../../utility/helper";
import { getLegacyDocService } from "../../../../../../services/viewWealth";
const LegacyComponent = ({ leagcyData }) => {
  const data = leagcyData || [];
  const percentage = "";
  const [showModal, setShowModal] = useState(false);
  const [currentDoc, setCurrentDoc] = useState(null);
  const accessToken = JSON.parse(localStorage.getItem("access_token"));
  const [docLoading, setDocLoading] = useState(false);
  const [docListData, setDocListData] = useState([]);
  const maxRows = data.reduce((max, legacy) => {
    return legacy.data?.length > max ? legacy.data.length : max;
  }, 0);

  useEffect(() => {
    if (currentDoc) {
      GetLegacyDocData(currentDoc?.item_id);
    }
  }, [currentDoc]);
  

  const handleEyeClick = (id) => {
    setCurrentDoc(id);
    setShowModal(true);
  };

  const GetLegacyDocData = async (currentDoc) => {
    setDocLoading(true);
    try {
      const response = await getLegacyDocService(currentDoc, accessToken);
      if (response.status === 200) {
        setDocListData(response?.data.data);
      } else {
        throw new Error("Failed to fetch user data");
      }
    } catch (err) {
      console.log(err);
    } finally {
      setDocLoading(false);
    }
  };

  return (
    <div className="flex items-center md:justify-center mt-20 w-full overflow-x-auto">
      <table className="border-collapse w-[70%] min-w-[800px] text-info dark:text-white">
        <thead>
          <tr className="border-b dark:border-white border-info font-bold text-justify">
            <th className="py-2">%</th>
            {data.map((legacy, i) => (
              <React.Fragment key={i}>
                <th className="py-2">{legacy.legacy_name}</th>
                <th className="py-2">doc</th>
              </React.Fragment>
            ))}
          </tr>
        </thead>
        <tbody>
          {Array.from({ length: maxRows }).map((_, rowIndex) => (
            <tr key={rowIndex}>
              {rowIndex === maxRows - 1 ? (
                <td className="py-2 text-lightPrimary dark:text-primary-gradient font-bold">{percentage}</td>
              ) : (
                <td></td>
              )}
              {data.map((legacy, colIndex) => {
                const itemData = legacy.data[rowIndex] || "";
                return (
                  <React.Fragment key={colIndex}>
                    <td className="text-lightPrimary dark:text-primary-gradient py-2">
                      {itemData ? itemData?.item_name : "-"}
                    </td>
                    <td className="py-2">
                      {itemData && (
                        <FaEye
                          className="cursor-pointer text-secondary text-justify"
                          onClick={() => handleEyeClick(itemData)}
                        />
                      )}
                    </td>
                  </React.Fragment>
                );
              })}
            </tr>
          ))}
          <tr className="border-t dark:border-white border-info font-bold text-lightPrimary dark:text-primary-gradient">
            <td className="py-2">Total</td>
            {data.map((legacy, i) => (
              <React.Fragment key={i}>
                <td className="py-2 ">
                  {formatNumber(legacy.total_initial_amount) || "-"}
                </td>
                <td></td>
              </React.Fragment>
            ))}
          </tr>
        </tbody>
      </table>
      {showModal && (
        <DocModal
          docData={currentDoc}
          docListData={docListData}
          onClose={() => {
            setShowModal(false);
            setCurrentDoc(null);
            setDocListData([]);
          }}
          docLoading={docLoading}
        />
      )}
    </div>
  );
};

export default LegacyComponent;
